import {useRef, useState, useEffect} from '@wordpress/element';
import {PaymentMethodDataProvider, usePaymentMethodDataContext} from '../../payment-methods/context';
import {useProcessPayment, useProcessPaymentFailure} from "../../payment-methods/hooks";

export const PaymentMethod = ({content, description = '', icons, ...props}) => {
    const el = useRef();
    const [container, setContainer] = useState(null);
    const Content = content;
    useEffect(() => {
        if (el.current) {
            setContainer(el.current);
        }
    }, []);
    return (
        <div ref={el} className={"wc-braintree-blocks-payment-method__container"}>
            {description &&
                <div className="wc-braintree-blocks-payment-method__description">
                    {description}
                </div>}
            <PaymentMethodDataProvider container={container} {...props}>
                <PaymentMethodProviderContainer {...props}>
                    <Content {...props}/>
                </PaymentMethodProviderContainer>
            </PaymentMethodDataProvider>
        </div>
    )
}

const PaymentMethodProviderContainer = (
    {
        children,
        name,
        onError,
        billing,
        gatewayId,
        shippingData,
        eventRegistration,
        emitResponse,
        activePaymentMethod,
        isExpress = false,
        advancedFraudOptions = {}
    }) => {
    const {
        onPaymentSetup,
        onCheckoutFail
    } = eventRegistration;
    const {
        responseTypes,
        noticeContexts
    } = emitResponse;

    const {
        fastlane
    } = usePaymentMethodDataContext();

    useProcessPayment({
        name,
        billing,
        gatewayId,
        shippingData,
        responseTypes,
        onPaymentSetup,
        useFastlane: fastlane.paymentToken !== null,
        activePaymentMethod,
        advancedFraudOptions
    });

    useProcessPaymentFailure({
        event: onCheckoutFail,
        onError: isExpress ? onError : null,
        responseTypes,
        paymentMethodId: name,
        activePaymentMethod,
        messageContext: isExpress ? noticeContexts.EXPRESS_PAYMENTS : null
    });
    return children;
}

export default PaymentMethod;